<template>
  <v-list>
    <v-list-item
      v-for="(child, index) in children"
      :key="index"
      @click="toClassChildrenRecords(child)"
    >
      <v-list-item-content>
        <div class="d-flex align-center justify-space-between">
          <div>
            {{ child.lastName }} {{ child.firstName }}
            <template v-if="child && checkAbsence(child)">
              <v-chip color="primary" class="mx-2" outlined small>出席</v-chip>
            </template>
          </div>

          <div class="d-flex">
            <v-icon>mdi-chevron-right</v-icon>
          </div>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>
<script lang="ts">
import {
  DiaryResponse,
  NurseryAttendanceResponse,
  NurseryChildResponse,
  NurseryClassResponse,
} from 'chaild-api/lib';
import Vue, { PropType, defineComponent} from 'vue';
export default defineComponent({
  props: {
    children: {
      type: Array as PropType<NurseryChildResponse[]>,
      required: true,
    },
    clas: {
      type: Object as PropType<NurseryClassResponse>,
      required: true,
    },
    absenceAttendance: {
      type: Array as PropType<NurseryAttendanceResponse[] | null>,
    },
    date: {
      type: Object as PropType<any>,
      required: true,
    },
    diaries: {
      type: Array as PropType<DiaryResponse[] | null>,
      required: true,
    },
  },
  computed: {},

  methods: {
    toClassChildrenRecords(child: NurseryChildResponse) {
      this.$router.push({
        path: `/record/class/${this.clas.classId}/child/${child.childId}`,
        query: { date: `${this.date.toISOString()}` }
        });
    },
    checkAbsence(child: NurseryChildResponse) {
      if (this.absenceAttendance) {
        this.absenceAttendance.find(attendance => attendance.child.childId === child.childId);
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.diary-text {
  background: #f5f6f6;
}
</style>
